import React from 'react'
import HomeAbout from '../home/HomeAbout'
import HowWork from '../home/HowWork'

const AboutUs = () => {
  return (
    <>

      <HomeAbout />
      <HowWork />

    </>
  )
}

export default AboutUs